import { render, staticRenderFns } from "./headerv.vue?vue&type=template&id=c1a837d4&scoped=true&"
import script from "./headerv.vue?vue&type=script&lang=js&"
export * from "./headerv.vue?vue&type=script&lang=js&"
import style0 from "./headerv.vue?vue&type=style&index=0&id=c1a837d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a837d4",
  null
  
)

export default component.exports